import { createFileRoute } from '@tanstack/react-router';

import { VacanciesPageContent } from '~/components/vacancies/VacanciesPageContent';
import { getOpenVacancies } from '~/lib/peopleforce';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const VacanciesPage = () => {
  const vacanciesData = Route.useLoaderData();

  return <VacanciesPageContent vacanciesData={vacanciesData} />;
};

export const Route = createFileRoute('/vacancies')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  loader: () => getOpenVacancies(),
  component: VacanciesPage,
});
